import { render } from "./PortfolioCard.vue?vue&type=template&id=1b9f89b7&scoped=true"
import script from "./PortfolioCard.vue?vue&type=script&lang=js"
export * from "./PortfolioCard.vue?vue&type=script&lang=js"

import "./PortfolioCard.vue?vue&type=style&index=0&id=1b9f89b7&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9f89b7"]])

export default __exports__